var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBeta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 22,
    viewBox: "0 0 48 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 22H0V0h48v22z",
    fill: "#D60022"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.126 18h4.068c1.998 0 2.97-1.116 2.97-2.934v-1.962c0-1.62-.756-2.178-1.44-2.43.612-.234 1.242-.774 1.242-2.268V7.218c0-1.782-.702-2.61-2.772-2.61H9.126V18zm3.42-11.592c.81 0 1.098.324 1.098 1.206v1.062c0 .882-.288 1.278-1.08 1.278h-1.08V6.408h1.062zm.018 5.472c.846 0 1.17.378 1.17 1.314v1.62c0 .954-.306 1.296-1.134 1.296h-1.116v-4.23h1.08zM17.915 4.608V18h5.994v-2.142h-3.654V12.15h2.952v-2.142h-2.952V6.696h3.546V4.608h-5.886zM27.149 18h2.394V6.732h2.16V4.608H24.97v2.124h2.178V18zM35.15 10.53c.217-1.44.36-2.448.433-3.204.054.756.18 1.728.414 3.204l.486 3.006h-1.8l.468-3.006zM37.204 18h2.304L37.113 4.608h-2.988L31.875 18h2.106l.378-2.466h2.448L37.203 18z",
    fill: "#fff"
  })));
}

SvgBeta.displayName = 'Beta';
export default SvgBeta;